import { Component, OnInit } from '@angular/core';
import { EcashService, MemberCardQuery, MemberQuery, config } from '@fgb/core';
import { TopUpViewModel } from '@fgb/core';
import { TopUpAmountTypeId } from '@fgb/core';
import { Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'fgb-topup',
  templateUrl: 'topup.component.html',
  styleUrls: ['./topup.component.scss'],
})
export class TopupComponent implements OnInit {
  amounts$: Observable<number[]>;
  amount: number;
  constructor(private ecashService: EcashService, private memberQuery: MemberQuery, private memberCardQuery: MemberCardQuery, private modalService: NgbModal) {}

  ngOnInit() {
    this.amounts$ = this.ecashService.getTopUpAmounts(TopUpAmountTypeId.TopUpAmount).pipe(
      tap(amounts => {
        if (amounts.length > 0) {
          this.amount = amounts[0];
        }
      })
    );
  }

  setAmount(amount: number) {
    this.amount = amount;
  }

  open(content: any) {
    let model: TopUpViewModel;
    let user = this.memberQuery.getValue().user;
    let memberCard = this.memberCardQuery.getCurrentCard();

    if (user && memberCard) {
      model = new TopUpViewModel(
        memberCard.ACN,
        this.amount,
        user.portalId,
        user.memberId,
        config.portalUrl + '/ecash/result',
        config.portalUrl + '/ecash/result'
      );
      this.ecashService.topUp([model]);
    }
    this.modalService.open(content);
  }
}
